import { create } from 'zustand';
import type { ModalState, ModalType, SidebarTab } from '../types/index.js';

interface UiState {
  sidebarOpen: boolean;
  activeTab: SidebarTab;
  modal: ModalState;
  sceneDetailOpen: boolean;

  setSidebarOpen: (open: boolean) => void;
  toggleSidebar: () => void;
  setActiveTab: (tab: SidebarTab) => void;
  openModal: (type: ModalType, payload?: unknown) => void;
  closeModal: () => void;
  setSceneDetailOpen: (open: boolean) => void;
}

export const useUiStore = create<UiState>((set) => ({
  sidebarOpen: true,
  activeTab: 'locations',
  modal: { type: null },
  sceneDetailOpen: false,

  setSidebarOpen: (sidebarOpen) => set({ sidebarOpen }),
  toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
  setActiveTab: (activeTab) => set({ activeTab }),
  openModal: (type, payload) => set({ modal: { type, payload } }),
  closeModal: () => set({ modal: { type: null } }),
  setSceneDetailOpen: (sceneDetailOpen) => set({ sceneDetailOpen }),
}));
